/**
 * QA-398 — 펀딩 일정 입력(datetime-local, yyyy-MM-ddTHH:mm)은 한국 시간(KST)이다.
 * 종전 등록 화면은 입력 뒤에 Z 를 붙여 UTC 로 보내 9시간 늦게 저장됐다(오후 1:50 → 화면 오후 10:50).
 */
const KST_PARTS = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** datetime-local(KST) → ISO(UTC). */
export const kstLocalToIso = (dateTimeLocal: string): string => new Date(`${dateTimeLocal}:00+09:00`).toISOString();

/** ISO → datetime-local(KST). 없거나 잘못되면 ''. */
export const isoToKstLocal = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const p = (type: Intl.DateTimeFormatPartTypes) => KST_PARTS.formatToParts(d).find((x) => x.type === type)?.value ?? '';
  return `${p('year')}-${p('month')}-${p('day')}T${p('hour')}:${p('minute')}`;
};
